<!-- 课程首页 -->
<template>
  <div class="el-CourseHome">
    <el-row class="content_block mb20 p20 head_course">
      <el-col :span="8">
        <el-image class="user_img" :src="user"></el-image>
        <template v-if="userType == 1">
          <p class="xm fontB">姓名：{{userInfo.studentName}}</p>
          <p class="gh_skm">学号：{{userInfo.studentSn}}</p>
        </template>
        <template v-else>
          <p class="xm fontB">姓名：{{userInfo.teacherName}}</p>
          <p class="gh_skm">工号：{{userInfo.teacherJobNumber}}</p>
        </template>
      </el-col>
      <i class="el-icon-close" @click="closePage" style="float: right;font-size: 24px;cursor: pointer;"></i>
    </el-row>
    <el-row class="content_block mb20 p20">
      <el-button :type="on_show==0?'primary':'plain'" class="mb20" @click="onShow(0)">
        <el-image class="content_img" style="float: left;" :src="on_show==0?ziye:ziye_f"></el-image>首页
      </el-button>
      <el-button :type="on_show==3?'primary':'plain'" class="mb20" @click="onShow(3)">
        <el-image class="content_img" style="float: left;" :src="on_show==3?kcheng_b:kcheng"></el-image>课程设置
      </el-button>
      <el-button :type="on_show==4?'primary':'plain'" class="mb20" @click="onShow(4)">
        <el-image class="content_img" style="float: left;" :src="on_show==4?zjie_b:zjie"></el-image>章节练习
      </el-button>
      <el-button :type="on_show==5?'primary':'plain'" class="mb20" @click="onShow(5)">
        <el-image class="content_img" style="float: left;" :src="on_show==5?caozuo_b:caozuo"></el-image>课程实操
      </el-button>
      <el-button v-if="courseType == 1" :type="on_show==10?'primary':'plain'" class="mb20" @click="onShow(10)">
        <el-image class="content_img" style="float: left;" :src="on_show==10?ktzsd_b:ktzsd"></el-image>课堂知识点
      </el-button>
      <courseIndex :courseId="courseId+''" :courseType="courseType+''" v-if="on_show == 0"></courseIndex>
      <SetUp :courseId="courseId+''" :courseType="courseType+''" v-if="on_show == 3"></SetUp>
      <Practice :courseId="courseId+''" :courseType="courseType+''" v-if="on_show == 4"></Practice>
      <!-- <TPractice :courseId="courseId+''" :courseType="courseType+''" v-if="on_show == 4 && userType == 2"></TPractice> -->
      <PracticalTraining :courseId="courseId+''" :courseType="courseType+''" :courseInfoName="courseInfo.teacherOpenCourseTitle" v-if="on_show == 5"></PracticalTraining>
      <!-- <TPracticalTraining :courseId="courseId+''" :courseType="courseType+''" :courseInfoName="courseInfo.teacherOpenCourseTitle" v-if="on_show == 5  && userType == 2"></TPracticalTraining> -->
      <KnowledgePoints :courseId="courseId+''" v-if="on_show == 10"></KnowledgePoints>
    </el-row>
  </div>
</template>

<script>
import courseIndex from "./components/index"; //课程首页
import SetUp from "./components/SetUp"; //课程设置
import Practice from "./components/Practice"; //章节练习
// import TPractice from "./components/TPractice"; //章节练习
import KnowledgePoints from "./components/KnowledgePoints"; //知识点管理
import PracticalTraining from "./components/PracticalTraining/PracticalTraining"; //课程实操
// import TPracticalTraining from "./components/PracticalTraining/TPracticalTraining"; //课程实操
export default {
  name: "MyCourse",
  components: {
  	courseIndex,
    SetUp,
    Practice,
    // TPractice,
    PracticalTraining,
    // TPracticalTraining,
    KnowledgePoints
  },
  data() {
    return {
      fuzhi:require("../../images/course/fuzhi@2x.png"),
      ziye_f:require("../../images/course/zhuye@2x.png"),
      tongzhi:require("../../images/course/tongzhi@2x.png"),
      zhishi:require("../../images/course/zhishi@2x.png"),
      tiwen:require("../../images/course/tiwen@2x.png"),
      xstw:require("../../images/course/xstw@2x.png"),
      ziye:require("../../images/course/ziye@2x.png"),
      kcheng:require("../../images/course/kcheng@2x.png"),
      kcheng_b:require("../../images/course/kecheng@2x.png"),
      zjie:require("../../images/course/zjie@2x.png"),
      caozuo:require("../../images/course/caozuo@2x.png"),
      caozuo_b:require("../../images/course/caozuo_b@2x.png"),
      ktzsd:require("../../images/course/ktzsd@2x.png"),
      ktzsd_b:require("../../images/course/ktzsd_b@2x.png"),
      kb:require("../../images/course/kb@2x.png"),
      kb_b:require("../../images/course/kb_b@2x.png"),
      qiandao:require("../../images/course/qiandao-xianxing@2x.png"),
      qiandao_b:require("../../images/course/qiandao-xianxing_b@2x.png"),
      hudongliaotian:require("../../images/course/hudongliaotian@2x.png"),
      hudongliaotian_b:require("../../images/course/hd_b@2x.png"),
      zuoye:require("../../images/course/task@2x.png"),
      zuoye_b:require("../../images/course/task_b@2x.png"),
      zjie_b:require("../../images/course/zj_b@2x.png"),
      kaoshi_2:require("../../images/course/kaoshi@2x_2.png"),
      kaoshi_2_b:require("../../images/course/kaoshi-b@2x.png"),
      cz_dftj:require("../../images/course/cz-dftj@2x.png"),
      cz_dftj_b:require("../../images/course/cj-b@2x.png"),
      user:this.$getHeadImg(),
      on_show:this.$ls.get(this.$getKeyInfo('on_show')) || 0,
      tabInfo:"tab_1",
      courseInfo:{
        teacherInfo:{}
      },
      userType:this.$Base64.decode(this.$ls.get(this.$getKeyInfo("userType"))), //获取用户类型 1：学生
      userInfo:this.$ls.get(this.$getKeyInfo("identityInfo")) || {},
      teacherOpenCourseChatLogId:null,
      courseId:this.$route.query.teacherOpenCourseId,
      UnreadNotice:null,//通知公告
      UnreadXstw:null,//学生提问
      UnreadTiwen:null,//教师提问
      tag:this.$route.query.index,
      timeIn:null,
      courseType:this.$route.query.courseType ,//课程类型 1：开课 2：授权课
    };
  },
  created() {
    if(!this.$isEmpty(this.$route.query.teacherOpenCourseId)){
      this.getInfo();
      //this.addSystem();
    }else{
      this.$message({message: '课程信息丢失！',type: 'warning'});
      let this_ = this;
      setTimeout(function(){
        this_.$router.go(-1);
      },500);
    }
    if(!this.$isEmpty(this.$route.query.teacherOpenCourseChatLogId)){
      this.teacherOpenCourseChatLogId = this.$route.query.teacherOpenCourseChatLogId;
    }
  },
  mounted() {

  },
  methods: {
    getInfo(){
      if(this.courseType == 1){
        this.$get("/jlw/teacherOpenCourse/view.json",{teacherOpenCourseId:this.courseId}).then((ret) =>{
          if(ret.code == 0){
            if(!this.$isEmpty(ret.data)){
              this.courseInfo = ret.data;
              this.$ls.set(this.$getKeyInfo("logName"),this.courseInfo.teacherOpenCourseTitle); //用于使用记录
            }
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }else{
        this.courseInfo.teacherOpenCourseTitle = this.$ls.get(this.$getKeyInfo("courseInfoName_"));
        this.$ls.set(this.$getKeyInfo("logName"),this.courseInfo.teacherOpenCourseTitle); //用于使用记录
      }

    },
    onShow(index,tabInfo){
      this.on_show = index;
      this.tabInfo = tabInfo;
      this.$ls.set(this.$getKeyInfo('on_show'),index);
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"课程中心",//一级名称
          secondName:this.courseInfo.teacherOpenCourseTitle,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    },
    closePage(){ //返回
      this.$router.go(-1);
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-CourseHome{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .head_course{
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        width: 120px;
        float: left;
        margin-right: 8%;
        text-align: center;
        padding: 10px;
        .head_img{
          width: 50px;
          height: 50px;
        }
        p{
          margin: 10px 0 0;
        }
        cursor: pointer;
      }
      .user_img{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        float: left;
        margin-right: 20px;
      }
      .gh_skm,.xm{
        margin: 10px 0;
      }
      .gh_skm{
        color: #858585;
      }
    }
    .content_img{
      width: 14px;margin-right: 10px;
      height: 14px;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/lookCourse/CourseHome.vue